import { z } from "zod";
import { questionSchema } from "./Question";

export const subCategorySchema = z.object({
  id: z.number(),
  content: z.string(),
  questions: z.array(questionSchema),
});

export type SubCategory = z.infer<typeof subCategorySchema>;
